/**
 * TODO: refactor to be 2 separate utils
 */

import type { ISpecialOffer } from "@jti/magento";
import { ISpecialOfferTypeEnum } from "@jti/magento";

export const enum PROMO_BUTTON_TYPE {
  LOGIN = "LOGIN",
  SIMILAR_PRODUCTS = "SIMILAR_PRODUCTS",
  ADD_TO_CART = "ADD_TO_CART",
  NONE = "NONE",
}

export const getPromoButtonType = (specialPromo: ISpecialOffer | undefined, isLoggedIn: boolean | null) => {
  if (!specialPromo) return PROMO_BUTTON_TYPE.ADD_TO_CART;
  const isEligible = specialPromo.eligible;
  const isPotentiallyEligible = specialPromo.potentially_eligible;

  if (isEligible && isLoggedIn) {
    return PROMO_BUTTON_TYPE.ADD_TO_CART;
  }

  if (!isEligible && isPotentiallyEligible && !isLoggedIn) {
    return PROMO_BUTTON_TYPE.LOGIN;
  }

  if (!isEligible && !isPotentiallyEligible) {
    return PROMO_BUTTON_TYPE.SIMILAR_PRODUCTS;
  }

  return PROMO_BUTTON_TYPE.NONE;
};

export const getConditionalPurchaseOffer = (specialOffers: ISpecialOffer[]) => {
  if (!specialOffers || specialOffers.length === 0) {
    return undefined;
  }
  const specialOffer = specialOffers.find(
    (offer: ISpecialOffer) => offer.type === ISpecialOfferTypeEnum.ConditionalPurchase
  );
  return specialOffer;
};
